import MuiPaper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export const Paper = styled(MuiPaper)(({ theme }) => ({
  width: '100%',
  marginBottom: 30,
  boxShadow: `0 0 0 1px ${theme.colors.primaryGrey}`,
  backgroundColor: 'transparent',
}));
